import React, { useEffect } from 'react'
import Avatar from '../Avatar'
import Typography from '../Typography'
import './conversationHeader.css'
import { MenuItem } from "react-bootstrap";
import CustomDropdown from '../CustomDropdown'
import { connect } from 'react-redux'
import { chatAction, messageAction } from '../../../../../store/action';
import { chatSelector, globalStateSelector } from '../../../../../store/selector';
import { profileStateReducer } from '../../../../../store/reducers';


function Index({ profile, type, listData, conversationList, status,teamName, dynamicUpdate, ...props }) {
  const { configProcessor ,currentUser ,getTeam } = props;
  const goOnline = () => {
    configProcessor('goOnline', { userState: 'online' })
  }
  const goOffline = () => {
    configProcessor('goOnline', { userState: 'offline' })
  }
  const changeStatus = () => {
    if(status === 'offline'){
      goOnline();
    } else {
      goOffline();
    }
  }
  useEffect(()=>{
    console.log("this is conversasion header : " ,currentUser , " team state " ,getTeam);
  },[props]);
  const primaryText = currentUser && currentUser.name ? currentUser.name : "No Name";
  const secondaryText = getTeam &&  getTeam.name;
  const image = profile && profile.image ;

  return (
    <div className={`conversation-header__outer`}>
      <div className='conversation-header__main gap-3'>
        <Avatar imageUrl={image} status={status} size="lg" showStatus={true} />
        <div className='d-flex flex-column conversation-header__for-ellipsis'>
          <Typography text={primaryText} />
          <Typography text={secondaryText} variant='secondary' />
        </div>
      </div>
      <CustomDropdown>
        <MenuItem>Settings</MenuItem>
        <MenuItem onClick={() => changeStatus()}>Go {status === 'online' ? 'Offline' : 'Online'}</MenuItem>
      </CustomDropdown>
    </div>
  )
}

const dispatchToProps = dispatch => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  }
});

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  getTeam : globalStateSelector.getSelectedTeam(state),
})
export default connect(stateToProps, dispatchToProps)(Index);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Conversation Header/index.js